import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "filters" }
const _hoisted_2 = { class: "grid grid-cols-2 md:grid-cols-2 gap-2 w-full" }

import { Select as ASelect } from 'ant-design-vue';
import {PrisonerFilters} from "@/@types/types";
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersComponent',
  props: {
    filters: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const selectedFilters = ref<Record<string, string[]>>({});

const emit = __emit;


watch(selectedFilters, (newVal, oldVal) => {
  emit('update:modelValue', newVal);
}, { deep: true });

// Convert array to Antd select options
const formatOptions = (array: string[]) => array
    .filter(item => item) // Remove falsy values like empty strings
    .map(item => ({ label: item, value: item }));

const updateSelectedFilters = (key: string, selectedOptions: string[]) => {
  console.log('Filters updated')
  selectedFilters.value[key] = selectedOptions;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (options, key) => {
        return (_openBlock(), _createElementBlock("div", { key: key }, [
          _createVNode(_unref(ASelect), {
            class: "w-full",
            mode: "multiple",
            options: formatOptions(options),
            placeholder: key,
            onChange: ($event: any) => (updateSelectedFilters(key, $event))
          }, null, 8, ["options", "placeholder", "onChange"])
        ]))
      }), 128))
    ])
  ]))
}
}

})